import React from "react";
import { useMediaQuery } from "@mui/material";
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import Footer from "../components/Footer";
import PageHeader from "../components/Auth/PageHeader";
import SignUp from "../components/Auth/SignUp";

const Signup = () => {
  // Use useMediaQuery to detect if the screen size is mobile
  const isMobile = useMediaQuery('(max-width: 990px)');
  return (
    <div>
      {!isMobile && <Header />} {/* Render Header only on desktop view */}
      {isMobile && <MobileHeader />}{" "}
      {/* Render MobileHeader only on mobile view */}
      <PageHeader
        title="Register"
        breadcrumbs={[{ label: "Home", link: "/" }, { label: "Register" }]}
      />
      <SignUp />
      <Footer />
    </div>
  );
};

export default Signup;
